import { Component, Watch } from 'vue-property-decorator'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import pdf from 'vue-pdf'
import AppSimpleSelector from '@/components/AppSimpleSelector.vue'
import AppSimpleTextField from '@/components/AppSimpleTextField.vue'
import { mixins } from 'vue-class-component'
import AccountDialog from '@/modules/Account/scripts/account-dialog'
import UploadProgress from '../components/UploadProgress.vue'
import { showNotification, showErrors } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'
import OcrDetailDialog from '@/components/OcrDetailDialog.vue'
import AppDialog from '@/components/AppDialog.vue'
import S3Handler from '@/mixins/s3'
import UploadFile from '../components/UploadFile.vue'
import { TextTask } from '../interfaces/textTract-task'
import AccountCertificateForm from '../components/AccountCertificateForm.vue'
import AccountCertificateDialog from '@/modules/AccountCertificate/scripts/account-certificate-dialog'
import { AccountCertificate, AccountCertificateType } from '@/modules/AccountCertificate/interfaces/account-certificate'
import { uploadFiles } from '@/modules/File/gql/file.gql'
import { newTextractTask, getTextractTaskStatus, getTextractTask } from '@/modules/OCR/gql'
import AppDatePicker from '@/components/AppDatePicker.vue'
import { createStatementByTextract } from '../gql'
import { editPolicy, getPolicyById } from '@/modules/Policy/gql/policy.gql'
import UploadSkeleton from '../components/UploadSkeleton.vue'
import { getAccount } from '@/modules/Account/gql/account.gql'
import { dateTimeToUnix, dateToDisplay, monthToDisplay, monthToParse } from '@/utils/dateTime'
import S3HandlerAI from '@/mixins/ai-s3'
@Component({
  components: {
    AppBreadcrumbs,
    pdf,
    AppSimpleSelector,
    AppSimpleTextField,
    UploadProgress,
    OcrDetailDialog,
    AppDialog,
    AccountCertificateForm,
    UploadFile,
    AppDatePicker,
    UploadSkeleton
  }
})
export default class OcrFileUpload extends mixins(AccountDialog, AccountCertificateDialog, S3Handler, S3HandlerAI) {
  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Insurance Cases'
    },
    {
      text: 'File Upload'
    }
  ]

  showUpload = false
  uploadFileType = ''
  targetFile: any

  pdfLoading = false
  textractTaskId = ''
  status = ''
  dataTimer = null as any
  textractTasksDetail: TextTask | null = null
  tableLoading = false
  updateMsgNum = 0

  form = {
    fileType: -1,
    clientName: 0,
    policy: 0,
    legalName: '',
    number: '',
    date: '',
    policyNumber: '',
    effectiveDate: '',
    expirationDate: '',
    carrierStatement: '',
    month: '',
    isClientName: false,
    isNumber: false,
    isDate: false,
    isPolicyNumber: false,
    isEffectiveDate: false,
    isExpirationDate: false,
    isCarrierStatement: false,
    isMonth: false
  }
  fileTypeOption = [
    'Policy',
    'Driver’s License',
    'Progressive Statement',
    'Country Wide Statement',
    'unrecognized'
  ]

  // 系统当前保单
  systemPolicy = {
    number: '',
    effectiveDate: '',
    expirationDate: ''
  }
  // 系统当前客户
  systemAccount = {
    name: '',
    idNumber: '',
    expirationDate: ''
  }
  // 系统当前对账单
  systemStatement = {
    month: ''
  }

  policyOption: string[] = []
  accountsOption: string[] = []
  policyOptionId: number[] = []
  accountsOptionId: number[] = []

  showDetailDialog = false
  updateSuccessDialog = {
    show: false
  }
  selected = null
  currentPage = 1
  totalPages = 0

  url: any = ''
  presumedFileType = {
    POLICY: 'Policy',
    DRIVER_LICENSE: 'Driver’s License',
    PROGRESSIVE_COMMISSION: 'Progressive Statement',
    COUNTRY_WIDE_COMMISSION: 'Country Wide Statement',
    UNRECOGNIZED: 'Unrecognized'
  }

  accountCertificateDialogLoading = false

  masterId: number | null = null

  accountId: number | null = null
  masterType = ''
  targetPolicy = null as any

  additionalInfoObject = null as any

  disabledSaveBtn = true

  loadingSaveBtn = false
  screenWidth = document.body.clientWidth
  timer = false
  showAddIcon = false
  activeAddIcon = false
  routerParams = {
    id: '',
    name: '',
    storeKey: '',
    jobStatus: ''
  }

  infoWarning = {
    show: false,
    text: ''
  }

  dateTimeToUnix = dateTimeToUnix
  dateToDisplay = dateToDisplay
  monthToDisplay = monthToDisplay
  monthToParse = monthToParse

  mounted () {
    const that = this
    window.onresize = () => {
      return (() => {
        that.screenWidth = document.body.clientWidth
      })()
    }
  }
  @Watch('screenWidth')
  changeScreenWidth (val: number) {
    if (!this.timer) {
      this.screenWidth = val
      this.timer = true
      let that = this
      setTimeout(() => {
        if (that.screenWidth <= 1390) {
          this.showAddIcon = true
        } else {
          this.showAddIcon = false
        }
        that.timer = false
      }, 400)
    }
  }

  @Watch('blobUrl')
  onMeChanged (val: string) {
    if (!val) {
      return
    }
    if (this.fileType === 'pdf') {
      this.getNumPages(val)
    } else {
      this.url = val
    }
  }
  @Watch('$route', { immediate: true })
  onRouteChanged (val: any) {
    const { id, storeKey, name } = val.params
    this.routerParams = { ...val.params }
    const { awsS3PrefixAI } = this
    if (id) {
      this.showUpload = true
      const url = awsS3PrefixAI + '/' + storeKey
      this.previewFileAI(url, name)
    }
  }

  // 从列表返回识别结果页
  @Watch('blobUrl')
  onBlobUrlChanged (val: string) {
    const { name, id } = this.routerParams
    if (!val || !id) {
      return
    }

    const { storeKeyAI } = this
    const type = name.split('.')[1]
    const file = {
      name,
      type: type
    }
    const info = {
      blobUrl: val,
      file,
      storeKey: storeKeyAI,
      targetFile: new File([val], file.name, { type: file.type })
    }
    this.onPreviewFile(info)
  }

  @Watch('textractTasksDetail', { deep: true })
  onTextractTasksDetailChanged (val: TextTask) {
    if (!val) {
      return
    }
    // 识别到的数据回显
    this.form.fileType = this.fileTypeOption.indexOf(this.presumedFileType[val.type])

    this.additionalInfoObject = JSON.parse(val.additionalInfoStr)
    if (val.type === 'POLICY') {
      if (val.presumedPolicies.length !== 0) {
        this.policyOption = val.presumedPolicies.map((item: any) => {
          return item.policyName
        })
        this.policyOptionId = val.presumedPolicies.map((item: any) => {
          return Number(item.id)
        })
      }
      this.disabledSaveBtn = !val.presumedPolicies.length
      this.getPolicyById()

      const { policyNumber, effectiveDate, expirationDate } = this.additionalInfoObject
      this.form.policyNumber = policyNumber || ''
      this.form.effectiveDate = this.dateTimeDisplay(effectiveDate) || ''
      this.form.expirationDate = this.dateTimeDisplay(expirationDate) || ''
      this.initAccount()
      this.initStatement()
    } else if (val.type === 'DRIVER_LICENSE') {
      const { name, idNumber, expirationDate } = this.additionalInfoObject
      this.accountsOption = val.presumedAccounts.map((item: any) => {
        return item.name
      })
      this.accountsOptionId = val.presumedAccounts.map((item: any) => {
        return Number(item.id)
      })
      this.getAccount()
      this.form.legalName = name || ''
      this.form.number = idNumber || ''
      this.form.date = this.dateTimeDisplay(expirationDate) || ''
      this.initPolicy()
      this.initStatement()
    } else if (val.type === 'PROGRESSIVE_COMMISSION' || val.type === 'COUNTRY_WIDE_COMMISSION') {
      this.form.month = this.additionalInfoObject.yearAndMonth ? dateTimeToUnix(this.additionalInfoObject.yearAndMonth).toString() : ''
      this.disabledSaveBtn = false
      this.initAccount()
      this.initPolicy()
    } else {
      this.initAccount()
      this.initPolicy()
      this.initStatement()
    }
  }

  @Watch('filesInfo', { deep: true })
  onFilesInfoChanged (val: any) {
    if (!val.length) {
      return
    }
    this.saveFile()
  }

  @Watch('form', { deep: true })
  onFormChanged (val: any) {
    this.getMasterType(val.fileType)
  }

  getMasterType (index: number) {
    const { policyOption, accountsOption } = this
    switch (index) {
      case 0:
        this.masterType = 'POLICY'
        this.disabledSaveBtn = !policyOption.length
        break
      case 1:
        this.masterType = 'ACCOUNT_CERTIFICATE'
        this.disabledSaveBtn = !accountsOption.length
        break
      case 2:
        this.masterType = 'STATEMENT'
        this.disabledSaveBtn = false
        break
      case 3:
        this.masterType = 'STATEMENT'
        this.disabledSaveBtn = false
        break
      default:
        this.disabledSaveBtn = true
    }
  }
  // 监听到上传成功
  onSuccessFile (url: string) {
    //
  }

  // 获得预览blob url开始检测
  onPreviewFile (info: any) {
    if (!info.blobUrl) {
      return
    }
    const { id, jobStatus } = this.routerParams

    this.showUpload = true
    if (!id || (id && jobStatus === 'DETECTING')) {
      this.pdfLoading = true
    }
    const { blobUrl, file, storeKey, targetFile } = info
    this.uploadFileType = file.type
    this.targetFile = targetFile
    this.showUpload = true // 优化时间
    if (!id) {
      this.newTextractTask(storeKey, file.name, file.size + '')
    } else {
      this.textractTaskId = id
      if (jobStatus === 'DETECTING') {
        this.getTextractTaskStatusRequest()
      } else {
        this.getTextractTask()
      }
    }

    if (file.type === 'pdf') {
      this.getNumPages(blobUrl)
    } else {
      this.url = blobUrl
    }
  }

  getNumPages (url: string) {
    var loadingTask = pdf.createLoadingTask(url)
    this.url = loadingTask
    loadingTask.promise.then((pdf1: any) => {
      this.totalPages = pdf1.numPages
    })
  }

  goToPage (pageNumber: number) {
    if (pageNumber >= 1 && pageNumber <= this.totalPages) {
      this.currentPage = pageNumber
    }
  }

  forbidDefaultEvent (e: any) {
    e.preventDefault()
  }

  async getTextractTask () {
    this.tableLoading = true
    try {
      const result = await this.$apollo.query({
        query: getTextractTask,
        variables: {
          textractTaskId: Number(this.textractTaskId)
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.textractTasksDetail = result.data.getTextractTask
      this.tableLoading = false
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
  // 新建识别单
  async newTextractTask (storeKey: string, name: string, size: string) {
    try {
      const res = await this.$apollo.mutate({
        mutation: newTextractTask,
        variables: {
          input: {
            storeKey,
            name,
            size
          }
        }
      })
      this.textractTaskId = res.data.newTextractTask.id
      this.getTextractTaskStatusRequest()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
  // 查询识别状态API
  async getTextractTaskStatus () {
    try {
      const result = await this.$apollo.query({
        query: getTextractTaskStatus,
        variables: {
          textractTaskId: Number(this.textractTaskId)
        }
      })
      this.status = result.data.getTextractTaskStatus
      if (this.status === 'success') {
        this.pdfLoading = false
        this.getTextractTask()
        return
      }
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
  // 查询识别状态轮询
  getTextractTaskStatusRequest () {
    this.dataTimer = setInterval(async () => {
      await this.getTextractTaskStatus()
      if (this.status === 'success') {
        clearInterval(this.dataTimer)
        this.getTextractTask()
      }
    }, 10000)
  }

  onChangeFiletype (index: number) {
    this.form.fileType = index
  }
  onChangeClientName (index: number) {
    this.form.clientName = index
    this.getAccount()
  }
  onChangePolicy (index: number) {
    this.form.policy = index
    this.getPolicyById()
  }
  // 创建客户成功
  onCreateAccountSuccess (id: number) {
    this.hideAcctEditDialog()
    this.accountsOptionId.push(Number(id))
    this.getAccount()
  }

  // 获得新建客户名字
  getNewAccountName (name: string) {
    this.accountsOption.push(name)
    this.form.clientName = this.accountsOption.length - 1
  }
  async confirmUpdate (e: any) {
    const { form, accountsOptionId, policyOptionId } = this
    switch (form.fileType) {
      case 0:
        if (this.masterId) {
          if (!form.isPolicyNumber && !form.isEffectiveDate && !form.isExpirationDate) {
            showNotification({
              msg: '至少选择一条需要保存的信息',
              type: SnackType.Error
            })
            return
          }
          this.loadingSaveBtn = true
          await this.editPolicyRequest()
          await this.onUploadFileToAttachments()
        } else {
          showNotification({
            msg: '没有识别到所对应的保单，不能保存',
            type: SnackType.Error
          })
        }
        break
      case 1:
        const { legalName, number, date, isClientName, isDate, isNumber } = this.form
        if (!isClientName && !isDate && !isNumber) {
          showNotification({
            msg: '至少选择一条需要保存的信息',
            type: SnackType.Error
          })
          return
        }
        // 新建
        const targetAccountCertificate = {
          type: AccountCertificateType.DRIVING_LICENSE,
          id: -1,
          name: isClientName ? legalName : '',
          expirationDate: isDate ? date : '',
          licenseNumber: isNumber ? number : ''
        } as AccountCertificate
        this.accountId = Number(accountsOptionId[form.clientName])
        this.targetAccountCertificate = targetAccountCertificate
        this.showAccountCertificateEditDialog(e, targetAccountCertificate)
        break
      case 2:
        // 对账单内容保存
        if (!form.isMonth) {
          showNotification({
            msg: '至少选择一条需要保存的信息',
            type: SnackType.Error
          })
          return
        }
        this.loadingSaveBtn = true
        await this.createStatementByTextractRequest()
        break
      case 3:
        // 对账单内容保存
        if (!form.isMonth) {
          showNotification({
            msg: '至少选择一条需要保存的信息',
            type: SnackType.Error
          })
          return
        }
        this.loadingSaveBtn = true
        await this.createStatementByTextractRequest()
        break
    }
  }

  confirmAccountCertificate () {

  }

  async saveAccountCertificateSuccess (id: number) {
    if (id !== -1) {
      this.masterId = +id
    }
    // 保存驾照成功
    const { isClientName, isNumber, isDate } = this.form
    const updateMsgNumArray = []
    updateMsgNumArray.push(isClientName, isNumber, isDate)
    const updateMsgNumArrays = updateMsgNumArray.filter((item: any) => { return item })
    this.updateMsgNum = updateMsgNumArrays.length
    await this.onUploadFileToAttachments()
  }

  // 上传文件
  async onUploadFileToAttachments () {
    this.filesToUpload.push(this.targetFile)
    if (!this.checkCredentialValid()) {
      await this.getSTSCredentials()
    }

    this.filePrefix = this.masterId + ''
    await this.uploadFileToS3(0)
  }

  // 保存文件
  async saveFile () {
    if (this.filesInfo.length === 0) {
      return
    }
    const { filesInfo, masterId, masterType, notes } = this

    const filesInput = filesInfo.map(fileInfo => {
      const { url, name, size, type } = fileInfo
      return {
        url: url,
        notes,
        name: name,
        size: size.toString(),
        type: masterType + '_ATTACHMENT'
      }
    })
    try {
      const result = await this.$apollo.mutate({
        mutation: uploadFiles,
        variables: {
          masterId: masterId,
          masterType: masterType,
          filesInput
        }
      })
      const res = result.data.uploadFiles
      if (res) {
        this.accountCertificateDialogLoading = false
        this.accountCertificateDialog.show = false
        this.updateSuccessDialog.show = true
        this.loadingSaveBtn = false
        this.filesInfo = []
      }
    } catch (e) {
      showErrors(e.graphQLErrors)
      this.accountCertificateDialogLoading = false
      this.accountCertificateDialog.show = false
      this.updateSuccessDialog.show = true
      this.loadingSaveBtn = false
      this.filesInfo = []
    }
  }
  // 保存对账单内容
  async createStatementByTextractRequest () {
    try {
      const res = await this.$apollo.mutate({
        mutation: createStatementByTextract,
        variables: {
          month: monthToParse(+this.form.month),
          textractId: Number(this.textractTaskId)
        }
      })
      this.masterId = Number(res.data.createStatementByTextract.id)
      this.updateMsgNum = 1
      this.onUploadFileToAttachments()
    } catch (e) {
      this.infoWarning.text = e.graphQLErrors[0].message
      if (e.graphQLErrors[0].message === 'This statement has been already uploaded') {
        this.infoWarning.show = true
        setTimeout(() => {
          this.infoWarning.show = false
          this.loadingSaveBtn = false
        }, 2000)
      } else {
        showErrors(e.graphQLErrors)
        this.loadingSaveBtn = false
      }
    }
  }
  // 查询保单信息
  async getPolicyById () {
    if (!this.policyOption.length) {
      return
    }
    const { policy } = this.form
    this.masterId = Number(this.policyOptionId[policy])
    // this.masterId = 13173
    this.tableLoading = true
    try {
      const result = await this.$apollo.query({
        query: getPolicyById,
        variables: {
          policyId: Number(this.masterId)
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.targetPolicy = result.data.getPolicyById
      this.systemPolicy.number = this.targetPolicy.policyNumber
      this.systemPolicy.effectiveDate = this.targetPolicy.effectiveDate
      this.systemPolicy.expirationDate = this.targetPolicy.expirationDate
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
  // 查询客户信息
  async getAccount () {
    if (!this.accountsOption.length) {
      return
    }
    const { accountsOptionId, form } = this
    const accountId = Number(accountsOptionId[form.clientName])

    this.accountId = accountId
    try {
      const result = await this.$apollo.query({
        query: getAccount,
        variables: {
          accountId
        }
      })
      const client = result.data.getAccount
      if (client) {
        this.systemAccount.name = client.name
      } else {
        this.systemAccount.name = ''
      }
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
  // 保存保单信息
  async editPolicyRequest () {
    const {
      policyName, type, status, originalInceptionDate,
      additionalInfoStr, cancelDate, nonRenew,
      installmentPlan,
      billingType, term, bindDate, premium, agencyFee, brokerFee, carrierPolicyFee, inspectionFee, taxesFee, stampingFee, productCommissionOverride, payerType,
      recordType, account, primaryContact, book, carrier, carrierProduct, generalAgent, source, insuranceQuote,
      writingAgents,
      inheritPolicies, policyNumber, effectiveDate, expirationDate
    } = this.targetPolicy

    const writingAgentIds = writingAgents.map((item: any) => { return Number(item.id) })

    try {
      const res = await this.$apollo.mutate({
        mutation: editPolicy,
        variables: {
          policyId: this.masterId,
          policyInput: {
            policyName: policyName || '',
            policyNumber: this.form.isPolicyNumber ? this.form.policyNumber : policyNumber,
            status,
            type,
            effectiveDate: this.form.isEffectiveDate ? this.form.effectiveDate ? this.form.effectiveDate + '' : null : effectiveDate + '',
            expirationDate: this.form.isExpirationDate ? this.form.expirationDate ? this.form.expirationDate + '' : null : expirationDate + '',
            originalInceptionDate: originalInceptionDate ? originalInceptionDate + '' : null,
            cancelDate: cancelDate ? cancelDate + '' : null,
            insuranceQuoteId: insuranceQuote ? Number(insuranceQuote.id) : null,
            nonRenew,
            additionalInfoStr: this.parsePoliyAdditionalInfo(),
            recordTypeId: Number(recordType.id),
            accountId: Number(account.id),
            primaryContactId: primaryContact ? Number(primaryContact.id) : null,
            sourceId: source ? Number(source.id) : null,
            carrierProductId: carrierProduct ? Number(carrierProduct.id) : null,
            priorTermId: inheritPolicies.fromPolicy ? Number(inheritPolicies.fromPolicy.id) : null,
            bookId: book ? Number(book.id) : null,
            carrierId: carrier ? Number(carrier.id) : null,
            gaId: generalAgent ? Number(generalAgent.id) : null,
            premium: premium ? Number(premium) : 0,
            agencyFee: agencyFee ? Number(agencyFee) : 0,
            carrierPolicyFee: carrierPolicyFee ? Number(carrierPolicyFee) : 0,
            inspectionFee: inspectionFee ? Number(inspectionFee) : 0,
            stampingFee: stampingFee ? Number(stampingFee) : 0,
            brokerFee: brokerFee ? Number(brokerFee) : 0,
            taxesFee: taxesFee ? Number(taxesFee) : 0,
            writingAgentIds: writingAgentIds || null,
            productCommissionOverride: productCommissionOverride || 0,
            term: term ? Number(term) : null,
            billingType,
            installmentPlan: installmentPlan ? Number(installmentPlan) : null,
            payerType
          }
        }
      })
      const { isPolicyNumber, isEffectiveDate, isExpirationDate } = this.form
      const updateMsgNumArray = []
      updateMsgNumArray.push(isPolicyNumber, isEffectiveDate, isExpirationDate)
      const updateMsgNumArrays = updateMsgNumArray.filter((item: any) => { return item !== false })
      this.updateMsgNum = updateMsgNumArrays.length
      return res.data.editPolicy.id
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  parsePoliyAdditionalInfo () {
    const { form, additionalInfoObject } = this
    const additionalInfo = {
      policyNumber: '',
      effectiveDate: '',
      expirationDate: ''
    }
    additionalInfo.policyNumber = form.isPolicyNumber ? this.form.policyNumber : additionalInfoObject.pageNumber
    additionalInfo.effectiveDate = form.isEffectiveDate ? form.effectiveDate : additionalInfoObject.effectiveDate
    additionalInfo.expirationDate = form.isExpirationDate ? form.expirationDate : additionalInfoObject.expirationDate
    return JSON.stringify(this.additionalInfoObject, (key, value) => {
      return value === 0 ? '0' : (value || '')
    })
  }
  dateTimeDisplay (dateStr: string) {
    if (!dateStr) {
      return
    }
    if (dateStr.indexOf('/') !== -1) {
      const dateParts = dateStr.split('/')
      const isoDate = dateParts[2].slice(0, 4) + '-' + dateParts[0].padStart(2, '0') + '-' + dateParts[1].padStart(2, '0')

      const timestamp = dateTimeToUnix(isoDate)
      return timestamp.toString()
    } else {
      return dateStr
    }
  }

  routeTo (name: string) {
    this.$router.push({
      name,
      params: {
        id: this.masterId + ''
      }
    })
  }

  routeToDetail () {
    switch (this.form.fileType) {
      case 0:
        this.routeTo('PolicyDetailDetail')
        break
      case 1:
        this.routeTo('AccountCertificateDetailDetail')
        break
      case 2:
        this.routeTo('StatementDetail')
        break
      case 3:
        this.routeTo('StatementDetail')
        break
    }
  }

  handleCancel () {
    this.showUpload = false
    this.routerParams = {
      id: '',
      name: '',
      storeKey: '',
      jobStatus: ''
    }
  }
  initAccount () {
    this.form.legalName = ''
    this.form.number = ''
    this.form.date = ''
    this.form.isClientName = false
    this.form.isNumber = false
    this.form.isDate = false
    this.systemAccount = {
      name: '',
      idNumber: '',
      expirationDate: ''
    }
    this.accountsOption = []
    this.form.clientName = -1
  }
  initPolicy () {
    this.form.policyNumber = ''
    this.form.effectiveDate = ''
    this.form.expirationDate = ''
    this.form.isPolicyNumber = false
    this.form.isEffectiveDate = false
    this.form.isExpirationDate = false
    this.systemPolicy = {
      number: '',
      effectiveDate: '',
      expirationDate: ''
    }
    this.policyOption = []
    this.form.policy = -1
  }
  initStatement () {
    this.form.month = ''
    this.form.isMonth = false
  }
}
